/**
 * @generated SignedSource<<13773984c152b0614a23977ed3fe74fa>>
 * @relayHash 758204416ec1c35eb472dcfba934fb83
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0c6c3e4f5926df2b58c96ecf077a734ea0bc76bb3687c7a2a84f0fbf32b22c73

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type useIsLoomEntryPointsEnabledQuery$variables = {
  cloudId: string;
  includeMeetingRecorderEligibility: boolean;
};
export type useIsLoomEntryPointsEnabledQuery$data = {
  readonly confluence_loomEntryPoints: {
    readonly isLoomEntryPointsEnabled: boolean;
  } | null;
  readonly loom_connectedCalendars?: ReadonlyArray<{
    readonly guid: string;
  } | null> | null;
  readonly loom_settings?: {
    readonly meetingNotesEligible: boolean | null;
    readonly meetingRecordingsAvailable: boolean | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"loomPersonalization_entryPoints">;
};
export type useIsLoomEntryPointsEnabledQuery = {
  response: useIsLoomEntryPointsEnabledQuery$data;
  variables: useIsLoomEntryPointsEnabledQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "includeMeetingRecorderEligibility"
  }
],
v1 = {
  "args": [
    {
      "kind": "Variable",
      "name": "cloudId",
      "variableName": "cloudId"
    }
  ],
  "concreteType": "ConfluenceLoomEntryPoints",
  "kind": "LinkedField",
  "name": "confluence_loomEntryPoints",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isLoomEntryPointsEnabled"
    }
  ]
},
v2 = [
  {
    "kind": "Variable",
    "name": "siteId",
    "variableName": "cloudId"
  }
],
v3 = {
  "condition": "includeMeetingRecorderEligibility",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "args": (v2/*: any*/),
      "concreteType": "LoomSettings",
      "kind": "LinkedField",
      "name": "loom_settings",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "meetingRecordingsAvailable"
        },
        {
          "kind": "ScalarField",
          "name": "meetingNotesEligible"
        }
      ]
    },
    {
      "args": (v2/*: any*/),
      "concreteType": "LoomConnectedCalendar",
      "kind": "LinkedField",
      "name": "loom_connectedCalendars",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "guid"
        }
      ]
    }
  ]
},
v4 = [
  (v1/*: any*/),
  (v3/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useIsLoomEntryPointsEnabledQuery",
    "selections": [
      (v1/*: any*/),
      (v3/*: any*/),
      {
        "kind": "InlineDataFragmentSpread",
        "name": "loomPersonalization_entryPoints",
        "selections": (v4/*: any*/),
        "argumentDefinitions": [
          {
            "kind": "RootArgument",
            "name": "cloudId"
          },
          {
            "kind": "RootArgument",
            "name": "includeMeetingRecorderEligibility"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useIsLoomEntryPointsEnabledQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "758204416ec1c35eb472dcfba934fb83",
    "id": "0c6c3e4f5926df2b58c96ecf077a734ea0bc76bb3687c7a2a84f0fbf32b22c73",
    "metadata": {},
    "name": "useIsLoomEntryPointsEnabledQuery",
    "operationKind": "query",
    "text": "query useIsLoomEntryPointsEnabledQuery($cloudId:ID!,$includeMeetingRecorderEligibility:Boolean!){confluence_loomEntryPoints(cloudId:$cloudId){isLoomEntryPointsEnabled},loom_settings(siteId:$cloudId)@include(if:$includeMeetingRecorderEligibility){meetingRecordingsAvailable,meetingNotesEligible}\n  loom_connectedCalendars(siteId:$cloudId)@include(if:$includeMeetingRecorderEligibility){guid},...loomPersonalization_entryPoints}fragment loomPersonalization_entryPoints on Query{confluence_loomEntryPoints(cloudId:$cloudId){isLoomEntryPointsEnabled},loom_settings(siteId:$cloudId)@include(if:$includeMeetingRecorderEligibility){meetingRecordingsAvailable,meetingNotesEligible}\n  loom_connectedCalendars(siteId:$cloudId)@include(if:$includeMeetingRecorderEligibility){guid}}"
  }
};
})();

(node as any).hash = "c3947215a2ac45ccf65d991a69c73b63";

export default node;
